import moment from 'moment-timezone';

import { StatusChipType } from '@salecycle/ui-component-library';

export const deriveStatus = (startDate: number, endDate: number, originalState: string): keyof StatusChipType => {
  const now = moment(new Date());
  const start = startDate ? moment(startDate) : undefined;
  const end = endDate ? moment(endDate) : undefined;

  if (originalState === 'Test' || originalState === 'Draft') {
    return originalState;
  }

  if (!start && !end) {
    return originalState as keyof StatusChipType;
  }

  if (!start && end) {
    if (end.isSameOrBefore(now)) {
      return 'Finished';
    }

    return 'Live';
  }

  if (start && !end) {
    if (start.isAfter(now)) {
      return 'Scheduled';
    }

    return 'Live';
  }

  if (start && end) {
    if (start.isSameOrBefore(now) && end.isAfter(now)) {
      return 'Live';
    }

    if (start.isAfter(now)) {
      return 'Scheduled';
    }

    if (start.isSameOrBefore(now) && end.isSameOrBefore(now)) {
      return 'Finished';
    }
  }

  return originalState as keyof StatusChipType;
};
